import { type ReactNode, useEffect, useRef } from "react";
import { Spinner } from "@getgreenline/blaze-ui";
import { ssoClient, ssoEnabled } from "../../lib/sso-client";
import { useAuthStore } from "../../stores/auth-store";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const loginTriggered = useRef(false);

  useEffect(() => {
    if (!ssoEnabled || isAuthenticated || loginTriggered.current) return;
    loginTriggered.current = true;
    ssoClient?.login();
  }, [isAuthenticated]);

  if (!ssoEnabled) return <>{children}</>;

  if (!isAuthenticated) {
    return (
      <div className="tw:flex tw:h-screen tw:items-center tw:justify-center">
        <Spinner className="tw:h-8 tw:w-8 tw:text-muted-foreground" />
      </div>
    );
  }

  return <>{children}</>;
}
